import { render, staticRenderFns } from "./WaveSurfer.vue?vue&type=template&id=219e0144&scoped=true&"
import script from "./WaveSurfer.vue?vue&type=script&lang=js&"
export * from "./WaveSurfer.vue?vue&type=script&lang=js&"
import style0 from "./WaveSurfer.vue?vue&type=style&index=0&id=219e0144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e0144",
  null
  
)

export default component.exports